"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComposedCard = void 0;

var react_1 = __importDefault(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var ComposedDetail_1 = require("./ComposedDetail");

var defaultClasses = 'row m-n3';

exports.ComposedCard = function (_a) {
  var className = _a.className,
      children = _a.children;
  return react_1.default.createElement("div", {
    className: clsx_1.default(defaultClasses, className),
    style: {
      columnGap: '15px'
    }
  }, children);
};

exports.ComposedCard.ComposedDetail = ComposedDetail_1.ComposedDetail;
exports.default = exports.ComposedCard;